import { render } from "./CrmDealKanbanDealDataModalTrashDealModal.vue?vue&type=template&id=e0287f58&scoped=true"
import script from "./CrmDealKanbanDealDataModalTrashDealModal.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanDealDataModalTrashDealModal.vue?vue&type=script&lang=js"

import "./CrmDealKanbanDealDataModalTrashDealModal.vue?vue&type=style&index=0&id=e0287f58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0287f58"]])

export default __exports__